interface IProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  type: 'DOC' | 'LINK' | 'VIDEO'
  iconSize?: number
  icon2Size?: number
}

export function IconSource({
  type,
  children,
  className,
  iconSize = 8,
  ...props
}: IProps) {
  const style = 'w-' + iconSize + ' ' + className

  switch (type) {
    case 'DOC':
      return (
        <>
          <div>
            <img {...props} className={style} src="/icon-pdf.svg" alt="icon" />
          </div>
          {children}
        </>
      )
    case 'LINK':
      return (
        <>
          <div>
            <img className={style} src="/icon-link.svg" alt="icon" />
          </div>
          {children}
        </>
      )
    case 'VIDEO':
      return (
        <>
          <div>
            <img className={style} src="/icon-video.svg" alt="icon" />
          </div>
          {children}
        </>
      )
  }
}
